import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Selectorispogzpkkfxv as Selector } from './Selector.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { requestFile23u83st3mccw5 as requestFile } from '../../../../../kiteui-library/com/lightningkite/kiteui/ExternalServices.mjs';
import {
  $3l5vvh8yg0ier as $,
  orPromise1iucc2to2udt2 as orPromise,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { serialNameFQN3cassnowfodm5 as serialNameFQN } from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/SerialDescriptor.ext.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { weight31wqab1913ly4 as weight } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { ExternalLink3fl954ixvn5zt as ExternalLink } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ExternalLink.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  _ServerFile___get_location__impl__ddyqaq3gnot90we5jhf as _ServerFile___get_location__impl__ddyqaq,
  ServerFile2veqsg2df5jtr as ServerFile,
} from '../../../../../service-abstractions-files-client/com/lightningkite/services/files/ServerFile.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
  get_unpadded1ygmnwh0rw79t as get_unpadded,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Frame.commonHtml.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  Companion_getInstance23x6zslwzj0st as Companion_getInstance,
  ImageLocal23zvpfzvp93up as ImageLocal,
  ImageRemote256pcav1ipbca as ImageRemote,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { ImageViewadm9fg4ms58f as ImageView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ImageView.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  TextView$_get_content_$ref_4pzcwl1tl9xt9sj2eem as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfbq6gzmblx5q7v as TextView$_set_content_$ref_pketfb,
} from '../auth/EmailProofComponent.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  substringAfterLast3r0t0my8cpqhk as substringAfterLast,
  substringBefore3n7kj60w69hju as substringBefore,
  isBlank1dvkhjjvox3p0 as isBlank,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  cellFormub3o1hqp20e5 as cellForm,
  labeledForm2ame2d0a5lql9 as labeledForm,
  labeledView3rpvir7z2o9ii as labeledView,
  Renderer1fhwti5gmwutm as Renderer,
} from './Renderer.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var TypeInfoClass;
function TypeInfo() {
  if (TypeInfoClass === VOID) {
    class $ {}
    initMetadataForClass($, 'TypeInfo');
    TypeInfoClass = $;
  }
  return TypeInfoClass;
}
function registerServerFile(_this__u8e3s4) {
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, 'com.lightningkite.services.files.ServerFile'), ServerFileRenderer_instance);
}
function ExternalLink$_get_enabled_$ref_1hoozk(p0) {
  return constructCallableReference(() => p0.get_enabled_pcr8o8_k$(), 0, 0, 172, VOID, [p0]);
}
function ExternalLink$_set_enabled_$ref_ssphcc(p0) {
  return constructCallableReference((p0_0) => {
    p0.set_enabled_tswf75_k$(p0_0);
    return Unit_instance;
  }, 1, 0, 173, VOID, [p0]);
}
function ExternalLink$_get_to_$ref_jqs3qa(p0) {
  return constructCallableReference(() => p0.get_to_kntnng_k$(), 0, 0, 174, VOID, [p0]);
}
function ExternalLink$_set_to_$ref_l7iod2(p0) {
  return constructCallableReference((p0_0) => {
    p0.set_to_ulc74x_k$(p0_0);
    return Unit_instance;
  }, 1, 0, 175, VOID, [p0]);
}
function ImageView$_get_source_$ref_ain7z1(p0) {
  return constructCallableReference(() => p0.get_source_jl0x7o_k$(), 0, 0, 176, VOID, [p0]);
}
function ImageView$_set_source_$ref_4jld67(p0) {
  return constructCallableReference((p0_0) => {
    p0.set_source_96c0pv_k$(p0_0);
    return Unit_instance;
  }, 1, 0, 177, VOID, [p0]);
}
function Button$_get_shown_$ref_hkylj1(p0) {
  return constructCallableReference(() => p0.get_shown_iyiju0_k$(), 0, 0, 178, VOID, [p0]);
}
function Button$_set_shown_$ref_bpvuvj(p0) {
  return constructCallableReference((p0_0) => {
    p0.set_shown_mavbz5_k$(p0_0);
    return Unit_instance;
  }, 1, 0, 179, VOID, [p0]);
}
function ServerFileRenderer$form$lambda$slambda($module, $rContext, $localFile, $value) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    var tmp0_elvis_lhs = $module.fileUpload_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var fileUpload = tmp;
    var tmp1_safe_receiver = yield* requestFile($rContext, VOID, $completion);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      yield* $localFile.set_revjhg_k$(tmp1_safe_receiver, $completion);
      yield* $value.set_revjhg_k$(yield* $(fileUpload(tmp1_safe_receiver, $completion), $completion), $completion);
    }
    return Unit_instance;
  }), 0);
}
var ServerFileRendererClass;
function ServerFileRenderer() {
  if (ServerFileRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'File Upload';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      priority_6ob4bq_k$(context, module_0) {
        return serialNameFQN(context.serializer_1.get_descriptor_wjt6a0_k$()) === 'com.lightningkite.services.files.ServerFile' ? 1.0 : -1.0;
      }
      priority_yxj3hb_k$(context, module_0) {
        return this.priority_6ob4bq_k$(context, module_0);
      }
      form_t58pa2_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(false);
          var localFile = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(null);
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          // Inline function 'com.lightningkite.kiteui.views.direct.externalLink' call
          var this_0 = weight(element, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (ExternalLink())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_0.willAddChild_hz2iwc_k$(element_0);
          element_0.set_newTab_2o3mwz_k$(true);
          var tmp = KMutableProperty0();
          var tmp_0 = ExternalLink$_get_enabled_$ref_1hoozk(element_0);
          var tmp_1 = getPropertyCallableRef('enabled', 0, tmp, tmp_0, ExternalLink$_set_enabled_$ref_ssphcc(element_0));
          element_0.invoke_bnq13k_k$(tmp_1, ($this$invoke) => !($this$invoke.invoke_r7m7el_k$(value) == null));
          var tmp_2 = KMutableProperty0();
          var tmp_3 = ExternalLink$_get_to_$ref_jqs3qa(element_0);
          var tmp_4 = getPropertyCallableRef('to', 0, tmp_2, tmp_3, ExternalLink$_set_to_$ref_l7iod2(element_0));
          element_0.invoke_bnq13k_k$(tmp_4, ($this$invoke) => {
            var tmp = $this$invoke.invoke_r7m7el_k$(value);
            var tmp0_safe_receiver = tmp == null ? null : tmp.location_1;
            var tmp_0;
            var tmp_1 = tmp0_safe_receiver;
            if ((tmp_1 == null ? null : new (ServerFile())(tmp_1)) == null) {
              tmp_0 = null;
            } else {
              tmp_0 = _ServerFile___get_location__impl__ddyqaq(tmp0_safe_receiver);
            }
            return tmp_0;
          });
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (RowOrCol())(element_0.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          element_0.willAddChild_hz2iwc_k$(element_1);
          element_1.set_vertical_nuap32_k$(false);
          // Inline function 'com.lightningkite.kiteui.views.card' call
          var this_1 = sizeConstraints(element_1, VOID, VOID, VOID, VOID, VOID, get_rem(3), get_rem(3));
          var tmp$ret$12 = themed(this_1, CardSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
          var this_2 = get_unpadded(tmp$ret$12);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_2 = new (Frame())(this_2.get_context_h02k06_k$());
          ensureOutermostElement(element_2);
          this_2.willAddChild_hz2iwc_k$(element_2);
          var tmp0 = get_centered(element_2);
          // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
          var icon = Companion_getInstance().download_1;
          // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_3 = new (IconView())(tmp0.get_context_h02k06_k$());
          ensureOutermostElement(element_3);
          tmp0.willAddChild_hz2iwc_k$(element_3);
          element_3.set_source_3o5lkf_k$(icon);
          element_3.set_description_s1386w_k$('File');
          element_3.onStartup_vrxh3i_k$();
          tmp0.addChild_2qpft2_k$(element_3);
          // Inline function 'com.lightningkite.kiteui.views.direct.image' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_4 = ImageView().new_com_lightningkite_kiteui_views_direct_ImageView_jbctb3_k$(element_2.get_context_h02k06_k$());
          ensureOutermostElement(element_4);
          element_2.willAddChild_hz2iwc_k$(element_4);
          var tmp_5 = KMutableProperty0();
          var tmp_6 = ImageView$_get_source_$ref_ain7z1(element_4);
          var tmp_7 = getPropertyCallableRef('source', 0, tmp_5, tmp_6, ImageView$_set_source_$ref_4jld67(element_4));
          element_4.invoke_bnq13k_k$(tmp_7, ($this$invoke) => {
            var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(localFile);
            var tmp;
            if (tmp0_safe_receiver == null) {
              tmp = null;
            } else {
              // Inline function 'kotlin.let' call
              tmp = ImageLocal().new_com_lightningkite_kiteui_models_ImageLocal_dt7oni_k$(tmp0_safe_receiver);
            }
            var tmp1_elvis_lhs = tmp;
            var tmp_0;
            if (tmp1_elvis_lhs == null) {
              var tmp_1 = $this$invoke.invoke_r7m7el_k$(value);
              var tmp2_safe_receiver = tmp_1 == null ? null : tmp_1.location_1;
              var tmp_2;
              var tmp_3 = tmp2_safe_receiver;
              if ((tmp_3 == null ? null : new (ServerFile())(tmp_3)) == null) {
                tmp_2 = null;
              } else {
                tmp_2 = _ServerFile___get_location__impl__ddyqaq(tmp2_safe_receiver);
              }
              var tmp3_safe_receiver = tmp_2;
              var tmp_4;
              if (tmp3_safe_receiver == null) {
                tmp_4 = null;
              } else {
                // Inline function 'kotlin.let' call
                tmp_4 = ImageRemote().new_com_lightningkite_kiteui_models_ImageRemote_yzp06t_k$(tmp3_safe_receiver);
              }
              tmp_0 = tmp_4;
            } else {
              tmp_0 = tmp1_elvis_lhs;
            }
            return tmp_0;
          });
          element_4.onStartup_vrxh3i_k$();
          element_2.addChild_2qpft2_k$(element_4);
          element_2.onStartup_vrxh3i_k$();
          this_2.addChild_2qpft2_k$(element_2);
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          var this_3 = get_centered(element_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          var this_4 = weight(this_3, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_5 = new (TextView())(this_4.get_context_h02k06_k$());
          ensureOutermostElement(element_5);
          this_4.willAddChild_hz2iwc_k$(element_5);
          element_5.set_ellipsis_rhzl3b_k$(true);
          element_5.set_wraps_9wisy1_k$(false);
          var tmp_8 = KMutableProperty0();
          var tmp_9 = TextView$_get_content_$ref_4pzcwl(element_5);
          var tmp_10 = getPropertyCallableRef('content', 0, tmp_8, tmp_9, TextView$_set_content_$ref_pketfb(element_5));
          element_5.invoke_bnq13k_k$(tmp_10, ($this$invoke) => {
            var tmp = $this$invoke.invoke_r7m7el_k$(value);
            var tmp0_safe_receiver = tmp == null ? null : tmp.location_1;
            var tmp_0;
            var tmp_1 = tmp0_safe_receiver;
            if ((tmp_1 == null ? null : new (ServerFile())(tmp_1)) == null) {
              tmp_0 = null;
            } else {
              tmp_0 = _ServerFile___get_location__impl__ddyqaq(tmp0_safe_receiver);
            }
            var tmp1_safe_receiver = tmp_0;
            var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : substringAfterLast(tmp1_safe_receiver, _Char___init__impl__6a9atx(47));
            var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : substringBefore(tmp2_safe_receiver, _Char___init__impl__6a9atx(63));
            var tmp_2;
            if (tmp3_safe_receiver == null) {
              tmp_2 = null;
            } else {
              // Inline function 'kotlin.takeUnless' call
              var tmp_3;
              if (!isBlank(tmp3_safe_receiver)) {
                tmp_3 = tmp3_safe_receiver;
              } else {
                tmp_3 = null;
              }
              tmp_2 = tmp_3;
            }
            var tmp4_elvis_lhs = tmp_2;
            return tmp4_elvis_lhs == null ? 'None' : tmp4_elvis_lhs;
          });
          element_5.onStartup_vrxh3i_k$();
          this_4.addChild_2qpft2_k$(element_5);
          element_1.onStartup_vrxh3i_k$();
          element_0.addChild_2qpft2_k$(element_1);
          element_0.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          var this_5 = get_centered(element);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_6 = new (Button())(this_5.get_context_h02k06_k$());
          ensureOutermostElement(element_6);
          this_5.willAddChild_hz2iwc_k$(element_6);
          var tmp_11 = KMutableProperty0();
          var tmp_12 = Button$_get_shown_$ref_hkylj1(element_6);
          var tmp_13 = getPropertyCallableRef('shown', 0, tmp_11, tmp_12, Button$_set_shown_$ref_bpvuvj(element_6));
          element_6.invoke_bnq13k_k$(tmp_13, ($this$invoke) => !(module_0.fileUpload_1 == null));
          // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
          var icon_0 = Companion_getInstance().upload_1;
          // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_7 = new (IconView())(element_6.get_context_h02k06_k$());
          ensureOutermostElement(element_7);
          element_6.willAddChild_hz2iwc_k$(element_7);
          element_7.set_source_3o5lkf_k$(icon_0);
          element_7.set_description_s1386w_k$('Upload');
          element_7.onStartup_vrxh3i_k$();
          element_6.addChild_2qpft2_k$(element_7);
          var rContext = element_6.get_context_h02k06_k$();
          onClick(element_6, VOID, VOID, VOID, ServerFileRenderer$form$lambda$slambda(module_0, rContext, localFile, value));
          element_6.onStartup_vrxh3i_k$();
          this_5.addChild_2qpft2_k$(element_6);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_t58pa2_k$(context, value, module_0);
      }
      view_7k7g0d_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.externalLink' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (ExternalLink())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_newTab_2o3mwz_k$(true);
          var tmp = KMutableProperty0();
          var tmp_0 = ExternalLink$_get_to_$ref_jqs3qa(element);
          var tmp_1 = getPropertyCallableRef('to', 0, tmp, tmp_0, ExternalLink$_set_to_$ref_l7iod2(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
            var tmp = $this$invoke.invoke_r7m7el_k$(value);
            var tmp0_safe_receiver = tmp == null ? null : tmp.location_1;
            var tmp_0;
            var tmp_1 = tmp0_safe_receiver;
            if ((tmp_1 == null ? null : new (ServerFile())(tmp_1)) == null) {
              tmp_0 = null;
            } else {
              tmp_0 = _ServerFile___get_location__impl__ddyqaq(tmp0_safe_receiver);
            }
            var tmp1_elvis_lhs = tmp_0;
            return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
          });
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          element_0.set_vertical_nuap32_k$(false);
          // Inline function 'com.lightningkite.kiteui.views.card' call
          var this_0 = sizeConstraints(element_0, VOID, VOID, VOID, VOID, VOID, get_rem(3), get_rem(3));
          var tmp$ret$7 = themed(this_0, CardSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
          var this_1 = get_unpadded(tmp$ret$7);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (Frame())(this_1.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          this_1.willAddChild_hz2iwc_k$(element_1);
          var tmp0 = get_centered(element_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
          var icon = Companion_getInstance().download_1;
          // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_2 = new (IconView())(tmp0.get_context_h02k06_k$());
          ensureOutermostElement(element_2);
          tmp0.willAddChild_hz2iwc_k$(element_2);
          element_2.set_source_3o5lkf_k$(icon);
          element_2.set_description_s1386w_k$('File');
          element_2.onStartup_vrxh3i_k$();
          tmp0.addChild_2qpft2_k$(element_2);
          // Inline function 'com.lightningkite.kiteui.views.direct.image' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_3 = ImageView().new_com_lightningkite_kiteui_views_direct_ImageView_jbctb3_k$(element_1.get_context_h02k06_k$());
          ensureOutermostElement(element_3);
          element_1.willAddChild_hz2iwc_k$(element_3);
          var tmp_2 = KMutableProperty0();
          var tmp_3 = ImageView$_get_source_$ref_ain7z1(element_3);
          var tmp_4 = getPropertyCallableRef('source', 0, tmp_2, tmp_3, ImageView$_set_source_$ref_4jld67(element_3));
          element_3.invoke_bnq13k_k$(tmp_4, ($this$invoke) => {
            var tmp = $this$invoke.invoke_r7m7el_k$(value);
            var tmp0_safe_receiver = tmp == null ? null : tmp.location_1;
            var tmp_0;
            var tmp_1 = tmp0_safe_receiver;
            if ((tmp_1 == null ? null : new (ServerFile())(tmp_1)) == null) {
              tmp_0 = null;
            } else {
              tmp_0 = _ServerFile___get_location__impl__ddyqaq(tmp0_safe_receiver);
            }
            var tmp1_safe_receiver = tmp_0;
            var tmp_2;
            if (tmp1_safe_receiver == null) {
              tmp_2 = null;
            } else {
              // Inline function 'kotlin.let' call
              tmp_2 = ImageRemote().new_com_lightningkite_kiteui_models_ImageRemote_yzp06t_k$(tmp1_safe_receiver);
            }
            return tmp_2;
          });
          element_3.onStartup_vrxh3i_k$();
          element_1.addChild_2qpft2_k$(element_3);
          element_1.onStartup_vrxh3i_k$();
          this_1.addChild_2qpft2_k$(element_1);
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          var this_2 = get_centered(element_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          var this_3 = weight(this_2, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_4 = new (TextView())(this_3.get_context_h02k06_k$());
          ensureOutermostElement(element_4);
          this_3.willAddChild_hz2iwc_k$(element_4);
          element_4.set_ellipsis_rhzl3b_k$(true);
          element_4.set_wraps_9wisy1_k$(false);
          var tmp_5 = KMutableProperty0();
          var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_4);
          var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_4));
          element_4.invoke_bnq13k_k$(tmp_7, ($this$invoke) => {
            var tmp = $this$invoke.invoke_r7m7el_k$(value);
            var tmp0_safe_receiver = tmp == null ? null : tmp.location_1;
            var tmp_0;
            var tmp_1 = tmp0_safe_receiver;
            if ((tmp_1 == null ? null : new (ServerFile())(tmp_1)) == null) {
              tmp_0 = null;
            } else {
              tmp_0 = _ServerFile___get_location__impl__ddyqaq(tmp0_safe_receiver);
            }
            var tmp1_safe_receiver = tmp_0;
            var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : substringAfterLast(tmp1_safe_receiver, _Char___init__impl__6a9atx(47));
            var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : substringBefore(tmp2_safe_receiver, _Char___init__impl__6a9atx(63));
            return tmp3_elvis_lhs == null ? 'None' : tmp3_elvis_lhs;
          });
          element_4.onStartup_vrxh3i_k$();
          this_3.addChild_2qpft2_k$(element_4);
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_7k7g0d_k$(context, value, module_0);
      }
      cellView_ge19t_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
            var tmp = $this$invoke.invoke_r7m7el_k$(value);
            var tmp0_safe_receiver = tmp == null ? null : tmp.location_1;
            var tmp_0;
            var tmp_1 = tmp0_safe_receiver;
            if ((tmp_1 == null ? null : new (ServerFile())(tmp_1)) == null) {
              tmp_0 = null;
            } else {
              tmp_0 = _ServerFile___get_location__impl__ddyqaq(tmp0_safe_receiver);
            }
            var tmp1_safe_receiver = tmp_0;
            var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : substringAfterLast(tmp1_safe_receiver, _Char___init__impl__6a9atx(47));
            var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : substringBefore(tmp2_safe_receiver, _Char___init__impl__6a9atx(63));
            return tmp3_elvis_lhs == null ? '\u2014' : tmp3_elvis_lhs;
          });
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      cellView_2dvin1_k$(context, value, module_0) {
        return this.cellView_ge19t_k$(context, value, module_0);
      }
      columnWidth_ocdoxa_k$(context, module_0) {
        return 12.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_ocdoxa_k$(context, module_0);
      }
    }
    protoOf($).cellForm_4mayde_k$ = cellForm;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'ServerFileRenderer', VOID, VOID, [Renderer()]);
    ServerFileRendererClass = $;
  }
  return ServerFileRendererClass;
}
var ServerFileRenderer_instance;
function ServerFileRenderer_getInstance() {
  return ServerFileRenderer_instance;
}
//region block: init
ServerFileRenderer_instance = new (ServerFileRenderer())();
//endregion
//region block: exports
export {
  TypeInfo as TypeInfop1ovm2u0cge0,
  registerServerFile as registerServerFile3pevtwdybn60v,
  ExternalLink$_set_to_$ref_l7iod2 as ExternalLink$_set_to_$ref_l7iod237nxghgvhqhbn,
  ExternalLink$_get_to_$ref_jqs3qa as ExternalLink$_get_to_$ref_jqs3qa3v9hculrvd9um,
};
//endregion

//# sourceMappingURL=ServerFileRenderer.mjs.map
